'use strict';

var DataLoaderPanelConstants = {
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  NOT_FOUND: 'NOT_FOUND',
  ERROR: 'ERROR'
};
module.exports = DataLoaderPanelConstants;